import React, { useRef, useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, Space, Divider, Button, Table, Statistic, Tabs, Descriptions, Popover } from 'antd';
import { motion } from 'motion/react';
import { EyeOutlined, TeamOutlined, CalendarOutlined, QuestionCircleOutlined, UpCircleFilled } from '@ant-design/icons';
import { dateFormat, shortDateFormat } from '../../utils';
import AddStage from '../../components/AddStage';
import UpdateSeason from '../../components/UpdateSeason';
import * as Setting from '../../utils/AuthUtils';
import UsageRatePie from '../../components/UsageRatePie';
import DeckPerformancePlot from '../../components/DeckPerformancePlot';
import { MeContext } from './../../context';
import { generateSeasonRankingCols, generateTop8RankingCols } from '../../utils/DataUtils';
import { t } from 'i18next';


function Season(props) {
  // console.warn('props di season: ', props);
  const ref = useRef(null);
  const metagameref = useRef(null);
  // const [isAdmin, setIsAdmin] = useState(false);
  const me = useContext(MeContext);
  const [width, setWidth] = useState(window.innerWidth);
  const [hasRights, setHasRights] = useState({isAdmin: false, isReferral: false});

  function handleWindowSizeChange() {
      setWidth(window.innerWidth);
  }

  useEffect(() => {
    // console.warn('onEffect di League page!');
    const rights = {isAdmin: false, isReferral: false};
    rights.isAdmin = (me && me.payLoad ? me.payLoad.isAdmin : false)
    const lid = (me && me.payLoad ? me.payLoad.leaguesManaged : 0)
    const lref = (props.season.data && props.season.data.payLoad ? props.season.data.payLoad.hostingLeague.id : 0)
    // console.warn('valori di lid e props.id: ', lid, ' , ', lref);
    rights.isReferral = (lid === lref ? true : false)
    // console.warn('stato di hasRights: ', hasRights);
    setHasRights(rights)
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
        window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, [me,props])

  const stageCols = [
    {
      title: 'Stage',
      dataIndex: 'name',
      key: 'name', 
      render: (text, record) => (<Space><Link to={'/stages/'+record.id+'/'}>{text}</Link></Space>)
    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: (date) => dateFormat(date)
    },
    {
      title: 'Players',
      dataIndex: 'playerAttendancy',
      key: 'playerAttendancy',
    },
    {
      title: '',
      dataIndex: 'id',
      render: (state, record) => (<Space><Link to={'/stages/'+record.id+'/'}>
                  <EyeOutlined />
              </Link>
              </Space>),
    }
  ];

  const dsCols = [
    {
      title: 'Deck',
      dataIndex: 'deckName',
      key: 'deckName',
    },
    {
      title: 'Usage',
      dataIndex: 'usageCount',
      key: 'usageCount',
    },
    {
      title: 'Usage Rate(%)',
      dataIndex: 'usageRate',
      key: 'usageRate',
    },
    {
      title: 'Points per Match',
      dataIndex: 'pointsRate',
      key: 'pointsRate',
    }
  ]

  function toggleViewRank(e) {
    e.preventDefault();
    ref.current?.scrollIntoView({behavior: 'smooth'});
    // navigate('#full-ranking-table', { replace: true });

  }

  function toggleViewMetagameStats(e) {
    e.preventDefault();
    metagameref.current?.scrollIntoView({behavior: 'smooth'});
  }

  function numbersPlayers(stages, rank) {
    if (stages && stages.length > 0) {
      var tp = 0;
      var besttp = 0;
      var count = 0;
      var bestcount = 0;
      var tup = rank.length;
      // TODO: we need to calculate the average player attendancy if there are multile leg per stage.
      // so we need to sum the playerAttendancy of each stage's leg and divide by the number of stage's legs that are done.
      // first we need to count the number of stages and then we count the number of legs in each stage that are done, then we can calculate the average player attendancy.
      var legCount = 0;
      var stageCount = [];
      var stageAttendancy = [];
      for (let i = 0; i < stages.length; i++) {
        if (stages[i].isDone) {
          stageCount.push(stages[i].stageNumber);
        }
      }
      // let's remove the duplicates from stageCount array, so we can count the number of stages that are done.
      stageCount = [...new Set(stageCount)];
      for (let i = 0; i < stageCount.length; i++) {
        for (let j = 0; j < stages.length; j++) {
          if (stages[j].stageNumber === stageCount[i] && stages[j].isDone) {
            legCount++;
            tp += stages[j].playerAttendancy;
          }
        }
        stageAttendancy.push(tp/legCount);
      }

      const averagePlayers = (stageAttendancy.length > 0 ? (stageAttendancy.reduce((a, b) => a + b, 0) / stageAttendancy.length).toFixed(2) : 0);

      console.warn('averagePlayers: ', averagePlayers, ' , stageAttendancy: ', stageAttendancy, ' , stageCount: ', stageCount, ' , legCount: ', legCount);

      tp = 0;
      stages.forEach(stage => {
        if (stage.isDone) { 
          count++;
          tp += stage.playerAttendancy;
        }
      });
      const ordStages = stages.slice();
      ordStages.sort((a,b) => b.playerAttendancy - a.playerAttendancy)
      for (let i = 0; i < ordStages.length && i < 5; i++) {
        if (ordStages[i].isDone) {
          bestcount++;
          besttp += ordStages[i].playerAttendancy;
        }
      }
      // console.warn('besttp e bestcount: ', besttp, ' , ', bestcount);
      return {
        totalUniquePlayers: tup,
        totalPlayers: tp,
        averagePlayers: (count > 0 ? (tp/count).toFixed(2) : 0),
        bestAveragePlayers: (bestcount > 0 && bestcount >= 5 ? (besttp/bestcount).toFixed(2) : 'N.A.(Not reached five stages)')
      };
    }
    return {
      totalUniquePlayers: '',
      totalPlayers: '',
      averagePlayers: '',
      bestAveragePlayers: '',
    }
  }

  const season = (props.season.data && props.season.data.payLoad !== null ? props.season.data.payLoad : {});
  const league = (props.season.data && props.season.data.payLoad !== null ? props.season.data.payLoad.hostingLeague : {});
  const stages = (props.stages.data && props.stages.data.payLoad !== null ? props.stages.data.payLoad : []);
  const top8 = (props.ranking.data && props.ranking.data.payLoad !== null ? props.ranking.data.payLoad.slice(0,8) : [])
  const rank = (props.ranking.data && props.ranking.data.payLoad !== null ? props.ranking.data.payLoad : [])
  const metagame = (props.metagame.data && props.metagame.data.payLoad !== null ? props.metagame.data.payLoad : [])
  const seasonId = (props.season.data && props.season.data.payLoad !== null ? props.season.data.payLoad.id : 0);
  const isMobile = width <= 768;
  const tabItems = [
    {
      key: 'usageRate',
      label: 'Decks Used',
      children: <UsageRatePie metagame={metagame} height={{ height: '650px' }}/>
    },
    {
      key: 'deckPerformance',
      label: 'Decks Performances',
      children: <DeckPerformancePlot metagame={metagame} height={{ height: '650px' }}/>
    },
    {
      key: 'rawData',
      label: 'General Stats',
      children: <Table columns={dsCols} dataSource={metagame} pagination={false} loading={props.metagame && !props.metagame.fulfilled && props.metagame.pending} scroll={{y:650}} />,
    }
  ]

  // 
  // console.warn(dataset);
  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
    <h1>
      {league.leagueName} - {season.name}
    </h1>
    <Card loading={props.season.isPending || props.metagame.isPending || props.ranking.isPending || props.stages.isPending}>
      <Row gutter={16} justify="center" align="middle">
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Statistic title="Participants" value={numbersPlayers(stages,rank).totalUniquePlayers} prefix={<TeamOutlined />} />
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Statistic title="Participants per Stage" value={numbersPlayers(stages,rank).averagePlayers} prefix={<TeamOutlined />} />
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Statistic title="Best Five Stages" value={numbersPlayers(stages,rank).bestAveragePlayers} prefix={<TeamOutlined />} />
        </Col>
        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
          <Statistic title="Scheduled Stages(Best of)" value={`${season.scheduledStages}(${season.bestStages})`} prefix={<CalendarOutlined />}/>
        </Col>
      </Row>
      { hasRights.isAdmin === true || hasRights.isReferral === true ? 
        <Row style={{ marginTop: '20px' }} justify="center" align="middle">
          <Col>
            <UpdateSeason season={season} />
          </Col>
        </Row>
      : null }
      <Divider>Summary</Divider>
      <Row gutter={[16, 24]} style={{ marginBottom: '20px' }} type="flex">
          { isMobile &&
          <Col className="gutter-row" xs={24} sm={24} md={24} lg={24} xl={24} style={{ 'display': 'inline-flex' }}> 
          <div>
            <h4>Stages</h4>
            { 
              stages.map(stage => {
                const stagelabels = [
                  {
                    key: '1',
                    label: 'Date',
                    children: <Space>{shortDateFormat(stage.date)}</Space>
                  },
                  {
                    key: '2',
                    label: 'Players',
                    children: <Space>{stage.playerAttendancy}</Space>
                  }
                ];
                return (
                  <Link to={'/stages/'+stage.id+'/'}>
                    <Card className="season-card" style= {{ width: '100%', marginBottom: '8px'}} title={stage.name}>
                      <Descriptions size="small" items={stagelabels} column={{ xs: 2, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }} />
                    </Card>
                  </Link>
                );
              })
            }
            { Setting.isLoggedIn() && (hasRights.isAdmin === true || hasRights.isReferral === true) && 
                <AddStage seasonId={seasonId} />
            }
            </div>
            </Col>
          }
          {!isMobile &&
            <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8} style={{ 'display': 'inline-flex' }}>
              <Card title="Stages" style={{ 'width': '100%' }}>
                <Table
                  rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
                  columns={stageCols} 
                  dataSource={stages} 
                  pagination={false} 
                  loading={props.stages && props.stages.isPending}
                  scroll={{y:440}}
                />
                { Setting.isLoggedIn() && (hasRights.isAdmin === true || hasRights.isReferral === true) && 
                  <AddStage seasonId={seasonId} />
                }
              </Card>
            </Col>
          }
        <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8} style={{ 'display': 'inline-flex' }}>
          <Card title="Top 8" style={{ 'width': '100%' }}>
            <Table
              columns={generateTop8RankingCols(t,season.rankingBonus,season.perfectBonus)} 
              dataSource={top8} 
              pagination={false} 
              loading={props.ranking && props.ranking.isPending}
            />
            <Button style={{ marginTop: 16 }} type="primary" onClick={toggleViewRank}>VIEW FULL RANKING</Button>
          </Card>
        </Col>
        <Col className="gutter-row" xs={24} sm={24} md={24} lg={8} xl={8} style={{ 'display': 'inline-flex' }}>
            <Card title="Metagame Stats" style={{ 'width': '100%' }}>
              <UsageRatePie metagame={metagame} />
              <Button style={{ marginTop: 16 }} type="primary" onClick={toggleViewMetagameStats}>VIEW FULL STATS</Button>
            </Card>
        </Col>
      </Row>
      <Divider>Season Ranking</Divider>
      <Row>
        <Col span={24}>
          <Card id='full-ranking-table' ref={ref}>
              <Table
                rowClassName={(record, index) => { if (index < 8) { return 'table-row-qualified' } else { if (index % 2 === 0) { return 'table-row-light' } return 'table-row-dark';}}} 
                columns={generateSeasonRankingCols(t,season.rankingBonus,season.perfectBonus)} 
                dataSource={rank} 
                pagination={false} 
                loading={props.ranking && props.ranking.isPending}
              />
          </Card>
        </Col>
      </Row>
      <Divider>Metagame Breakdown</Divider>
      <Row>
        <Col span={24}>
          <Card id='full-metagame-table' ref={metagameref}>
            <Tabs 
              centered
              items={tabItems}
            />
          </Card>
        </Col>
      </Row>
    </Card>
    </motion.div>
  );
}

export default Season;